<div class="badge-host">
  <span
    [ngClass]="
      view.badgeClass
        ? ['badge', 'badge-ellipsis', view.badgeClass]
        : ['badge-ellipsis', 'text-secondary', 'fw-semibold']
    "
  >
    {{ view.labelKey ?? "" | translate }}

    @if (view.infoTooltipKey) {
    <i
      class="fas fa-info-circle info-inline"
      [attr.title]="view.infoTooltipKey | translate"
    ></i>
    }
  </span>
</div>
